/* eslint-disable array-callback-return */
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useToasts } from 'react-toast-notifications'

import { DEFAULT_DELIVERY_OPTION } from '_utils/constant'
import { getCreateEventData, setCreateEventData } from '_utils/localData'

import deliveryEventApi from '_api/deliveryEvent'
import { updateRememberedDeliveryZones } from '_redux/modules/deliveryEvent'
import { useDispatch, useSelector } from 'react-redux'
import { LIST_TIME } from '../../../utils/constant'
import DeliveryOptionsModal from './DeliveryOptionsModal'

export const AddDeliveryOption = (props) => {
  const dispatch = useDispatch()
  const { hiddenDelivery: defaultVal, setValue, getValues } = props
  const { addToast } = useToasts()

  const { selectedShop } = useSelector((state) => state.shop)

  const eventData = getCreateEventData() || {}
  const { deliveryOption = {} } = eventData

  const [checked, setChecked] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [deliveryZones, setDeliveryZones] = useState([])
  const [deliveryTime, setDeliveryTime] = useState(
    new Date(new Date().getTime() + 24 * 8 * 60 * 60 * 1000)
  )

  const [deliveryHourStart, setDeliveryHourStart] = useState('10AM')
  const [deliveryHourEnd, setDeliveryHourEnd] = useState('1PM')
  const [validationError, setValidationError] = useState('')

  const toggleModal = () => {
    setOpenModal(!openModal)
  }

  const handleChange = (e) => {
    const isCheck = e.target.checked
    setChecked(isCheck)
    if (isCheck) {
      setOpenModal(true)

      setCreateEventData({
        ...eventData,
        addDelivery: true,
      })
    } else {
      setValue('addDelivery', false)
      setCreateEventData({
        ...eventData,
        addDelivery: false,
      })
      setValidationError('')
    }
  }

  useEffect(() => {
    if (deliveryOption && Object.keys(deliveryOption).length) {
      // eslint-disable-next-line no-shadow
      const { deliveryZones, deliveryTime, deliveryHourStart, deliveryHourEnd } = deliveryOption

      setDeliveryZones([...deliveryZones])
      const deliveryTimeSplit = deliveryTime.split(' ')[0].split('-').reverse()
      setDeliveryTime(
        new Date(deliveryTimeSplit[0], deliveryTimeSplit[1] - 1, deliveryTimeSplit[2])
      )

      setDeliveryHourStart(deliveryHourStart)
      setDeliveryHourEnd(deliveryHourEnd)
    } else {
      const getRemembered = async () => {
        const { msgResp } = await deliveryEventApi.getRememberedDeliveryZones(selectedShop.id)
        if (msgResp.length > 0) {
          setDeliveryZones([...msgResp])
        }
      }
      getRemembered()
    }
  }, [Object.keys(deliveryOption).length, checked])

  useEffect(() => {
    if (!defaultVal) {
      setValue('deliveryOption', {})
      setValue('addDelivery', false)
      setCreateEventData({
        ...eventData,
        addDelivery: false,
      })
    } else {
      setChecked(defaultVal)
    }
  }, [defaultVal])

  useEffect(() => {
    if (
      getValues()?.collectionDate &&
      getValues()?.collectionTimeStart &&
      getValues()?.collectionTimeEnd
    ) {
      setDeliveryTime(getValues()?.collectionDate)
      setDeliveryHourStart(getValues()?.collectionTimeStart)
      setDeliveryHourEnd(getValues()?.collectionTimeEnd)
      setValue('collectionDate', null)
      setValue('collectionTimeStart', '')
      setValue('collectionTimeEnd', '')
    }
  }, [
    getValues()?.collectionDate,
    getValues()?.collectionTimeStart,
    getValues()?.collectionTimeEnd,
  ])

  const validateDeliveryTimes = (start, end) => {
    const startTime = LIST_TIME.find((item) => item.text === start.label)?.value
    const endTime = LIST_TIME.find((item) => item.text === end.label)?.value

    if (startTime >= endTime) {
      setValidationError('End time must be greater than start time')
      return false
    }

    setValidationError('')
    return true
  }

  const handleOnClickOk = () => {
    if (!validateDeliveryTimes(deliveryHourStart, deliveryHourEnd)) {
      return
    }

    const data = deliveryZones.filter((item) => {
      if (item.name && item.price >= 0) {
        return item
      }
    })

    const deliveryOptionState = {
      deliveryZones: data,
      deliveryTime: moment(deliveryTime).format('DD-MM-YYYY'),
      deliveryHourStart,
      deliveryHourEnd,
    }

    setDeliveryZones(JSON.parse(JSON.stringify(data)))
    setCreateEventData({
      ...eventData,
      deliveryOption: deliveryOptionState,
      addDelivery: true,
    })
    setValue('deliveryOption', deliveryOptionState)
    setValue('addDelivery', true)
    toggleModal()
  }

  const onChangeZoneDelivery = (index, type, value) => {
    deliveryZones[index][type] = value
    setDeliveryZones([...deliveryZones])
  }

  const handleOnRemoveDeliveryZone = (index) => {
    deliveryZones.splice(index, 1)
    setDeliveryZones(JSON.parse(JSON.stringify([...deliveryZones])))
  }

  const handleAddMoreDeliveryZone = () => {
    setDeliveryZones(JSON.parse(JSON.stringify([...deliveryZones, DEFAULT_DELIVERY_OPTION])))
  }

  const handleRemoveRemember = async () => {
    try {
      await dispatch(
        updateRememberedDeliveryZones({
          shopId: selectedShop.id,
          rememberedDeliveryZones: [],
        })
      )
    } catch ({ msgResp }) {
      addToast(msgResp, { appearance: 'error', autoDismiss: true })
    }
  }

  const onChangeTimeDelivery = (e) => {
    setDeliveryTime(e ?? moment().toDate())
    setValue('collectionDate', e ?? moment().toDate())
  }

  const getDeliveryTime = (time) => {
    // 4: "00PM"
    if (typeof time === 'string' && time.length <= 4) {
      return { value: time, label: time }
    }

    return time
  }

  const onChangeDeliveryHourStart = (value) => {
    validateDeliveryTimes(value, getDeliveryTime(deliveryHourEnd))
    setDeliveryHourStart(value)
  }

  const onChangeDeliveryHourEnd = (value) => {
    validateDeliveryTimes(getDeliveryTime(deliveryHourStart), value)
    setDeliveryHourEnd(value)
  }

  return (
    <div className='havebg' data-testid='event-delivery'>
      <div className='row'>
        <div className='col-12'>
          <div className='custom-control custom-checkbox'>
            <input
              id='deliveryOptionCheckBox'
              type='checkbox'
              onChange={(e) => handleChange(e)}
              className='custom-control-input'
              checked={checked}
            />
            <label className='custom-control-label' htmlFor='deliveryOptionCheckBox'>
              Add Delivery Options
            </label>
          </div>
          <small className='error'></small>
        </div>
      </div>
      {openModal && (
        <DeliveryOptionsModal
          modal={openModal}
          toggle={toggleModal}
          handleOnClickOk={handleOnClickOk}
          handleRemoveRemember={handleRemoveRemember}
          deliveryZones={deliveryZones}
          deliveryTime={deliveryTime}
          onChangeZoneDelivery={onChangeZoneDelivery}
          onChangeTimeDelivery={onChangeTimeDelivery}
          handleOnRemoveDeliveryZone={handleOnRemoveDeliveryZone}
          handleAddMoreDeliveryZone={handleAddMoreDeliveryZone}
          deliveryHourStart={deliveryHourStart}
          onChangeDeliveryHourStart={onChangeDeliveryHourStart}
          deliveryHourEnd={deliveryHourEnd}
          onChangeDeliveryHourEnd={onChangeDeliveryHourEnd}
          validationError={validationError}
          {...props}
        />
      )}
    </div>
  )
}
